import React, { useState, useEffect } from "react";

import * as C from "components/common";
import * as S from "./sellNftElement";

import { MainSell } from "components/userNftDetail/userNftDetailElement";
import cardImg from "assets/boy-robot.png";
import { useAppDispatch, useAppSelector } from "store/store";
import { MainModel } from "components";
import { mainModel } from "store/redux/slices/helperSlices/modelSlice";
import { AiOutlineArrowLeft } from "react-icons/all";
import { useNavigate, useParams } from "react-router";
import {
  UserNFTDetailsHook,
  useForm,
  CreateTransactionHook,
  useWindowScrollPositions,
  SellNftHook,
  GetNftByTokenIdHook,
  GetNftTransactionHook,
  DeleteSellNftHook,
  GetRefreeAddressHook,
} from "hooks";
import { ContractUtility, shareholders } from "utility";
import { ToastMessage, Loader } from "components/common";
import { sellValidate } from "components/validation/customValidator";
import { createSellNftData } from "store/redux/slices/nftSlices/nftDataSlice";
import { ERC20Service } from "utility/services/erc20";
import { CommonUtility } from "utility/common";
import openNotification from "components/common/toastMessage/toastMessage";
import { connectModelSlice } from "store/redux/slices/helperSlices/modelSlice";

const SellNftComponent = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { scrollX, scrollY } = useWindowScrollPositions();

  const { web3, account, chainId, signer, swapSdk, paymentTokens } =
    useAppSelector((state) => state.web3Connect);

  const [isMainSell, setIsMainSell] = useState(false);
  const [idObj, setIdObj] = useState(null);
  const [connectModel, setConnectModel] = useState(false);
  const [value, setValue] = useState("");
  const [amount, setAmount] = useState<any>(0);
  const [tokenDecimals, setTokenDecimals] = useState<any>(0);

  const { nftData, error, nftLoading } = UserNFTDetailsHook(
    ContractUtility.getNetwork(chainId),
    account && account,
    idObj?.tokenId,
    idObj?.tokenAddress
  );
  const { data, loading, getNft } = GetNftByTokenIdHook();
  const { sell, createSellNft } = SellNftHook();
  const { getReferee } = GetRefreeAddressHook();
  const { getTx, data: tx, refetch } = GetNftTransactionHook();
  const {
    data: unlistData,
    loading: unlistLoading,
    deleteSellNft,
  } = DeleteSellNftHook();
  const { createTransaction, loading: transactionLoading } =
    CreateTransactionHook();

  useEffect(() => {
    if (nftData) {
      getNft(params?.id);
      getTx(params?.id);
    }
  }, [nftData]);

  useEffect(() => {
    unlistData && refetch();
  }, [unlistData]);

  useEffect(() => {
    if (scrollY > 100) {
      setIsMainSell(true);
    } else {
      setIsMainSell(false);
    }
  }, [scrollY]);
  useEffect(() => {
    params && setIdObj(CommonUtility.deStructureNftId(params?.id));
  }, [params]);

  const handleTokenDecimals = async () => {
    let decimals = await ERC20Service.decimals(web3, value);
    setTokenDecimals(decimals);
  };
  useEffect(() => {
    if (web3 && value) {
      handleTokenDecimals();
    }
  }, [web3, value]);

  const unlist = () => {
    try {
      deleteSellNft(tx);
    } catch (error) {
      console.log(error, "error on unlisting");
    }
  };

  const backToUserDetails = () => {
    navigate(`/user-nft/${params.id}?chain=${chainId}`);
  };
  //swak
  const createOrder = async () => {
    try {
      let userSigner: any = signer;
      let nftSwapSdk: any = swapSdk;
      dispatch(createSellNftData({ ...createSellNft, loading: true }));
      if (tx?.status === "LISTED") {
        openNotification(
          "Listed",
          "Nft already listed on marketplace",
          "warning"
        );
      } else {
        const TAKER_ASSET = {
          tokenAddress: value,
          amount: CommonUtility.handleMulDecimals(amount, tokenDecimals, 0),
          type: "ERC20",
        };

        const MAKER_ASSET = {
          tokenAddress: idObj.tokenAddress,
          tokenId: idObj.tokenId,
          type: nftData?.asset_contract?.schema_name,
          amount: CommonUtility.handleMulDecimals(amount, tokenDecimals, 0),
        };

        const walletAddressUserA = await userSigner?.getAddress();

        const assetsToSwapMaker = [MAKER_ASSET];
        const assetsToSwapTaker = [TAKER_ASSET];
        // approving makerAsset to swapSdk
        const approvalStatusForUserA = await nftSwapSdk?.loadApprovalStatus(
          assetsToSwapMaker[0],
          walletAddressUserA
        );
        // If we do need to approve makers assets for swapping, do that
        if (!approvalStatusForUserA.contractApproved) {
          const approvalTx = await nftSwapSdk.approveTokenOrNftByAsset(
            assetsToSwapMaker[0],
            walletAddressUserA
          );
          const approvalTxReceipt = await approvalTx.wait();
        }

        let networkName = await web3.eth.net.getNetworkType();
        let addresses = ContractUtility.getContractAddress(networkName);

        const referrer = await getReferee(walletAddressUserA);

        let companyShare;
        let referrerShare;
        let order;

        const nethtyShare = CommonUtility.handleMulDecimals(
          (amount * 1.5) / 100,
          tokenDecimals,
          0
        );

        if (referrer) {
          companyShare = CommonUtility.handleMulDecimals(
            (amount * 0.25) / 100,
            tokenDecimals,
            0
          );

          referrerShare = CommonUtility.handleMulDecimals(
            (amount * 0.5) / 100,
            tokenDecimals,
            0
          );

          order = nftSwapSdk.buildOrder(
            assetsToSwapMaker[0],
            assetsToSwapTaker[0],
            walletAddressUserA,
            {
              fees: [
                {
                  recipient: addresses.nethtyAddress,
                  amount: nethtyShare,
                },
                {
                  recipient: addresses.companyAddress,
                  amount: companyShare,
                },
                {
                  recipient: referrer,
                  amount: referrerShare,
                },
              ],
            }
          );
        } else {
          companyShare = CommonUtility.handleMulDecimals(
            (amount * 0.75) / 100,
            tokenDecimals,
            0
          );

          order = nftSwapSdk.buildOrder(
            assetsToSwapMaker[0],
            assetsToSwapTaker[0],
            walletAddressUserA,
            {
              fees: [
                {
                  recipient: "0xF26EBe41F9e9eF53e468a53A5f53af710a6890Ec",
                  amount: nethtyShare,
                },
                {
                  recipient: "0xaC8901a209c63eD86B03A4DE17dE67CF8575b20B",
                  amount: companyShare,
                },
              ],
            }
          );
        }

        // Signing the order using the maker's wallet address
        const signedOrder = await nftSwapSdk.signOrder(
          order,
          walletAddressUserA,
          signer
        );
        const recipients = [
          {
            name: shareholders.COMPANY,
            address: addresses.companyAddress,
            amount: companyShare,
          },
          {
            name: shareholders.NETHTY,
            address: addresses.nethtyAddress,
            amount: nethtyShare,
          },
          {
            name: shareholders.REFERRER,
            address: referrer,
            amount: referrerShare,
          },
        ];
        sell(
          account,
          signedOrder,
          nftData,
          params?.id,
          recipients
          // CommonUtility.handleMulDecimals(amount, tokenDecimals, 0)
        );

        createTransaction({
          nft_id: params?.id,
          amount: CommonUtility.handleMulDecimals(
            amount,
            tokenDecimals,
            0
          ).toString(),
          transaction_hash: data?.transaction_hash,
          network_id: chainId ? +chainId : "",
          status: "LISTED",
        });
      }
    } catch (err) {
      console.log("err", err);
      dispatch(createSellNftData({ ...createSellNft, loading: false }));
    }
  };

  const { handleSubmit, errors } = useForm(createOrder, sellValidate, {
    tokenAddress: value,
    amount: CommonUtility.handleMulDecimals(amount, tokenDecimals, 0),
  });

  useEffect(() => {
    createSellNft.error && ToastMessage("Error", createSellNft.error, "error");
    return () => {
      dispatch(createSellNftData({ ...createSellNft, error: "" }));
    };
  }, [createSellNft.error]);

  useEffect(() => {
    createSellNft?.data !== null && refetch();
  }, [createSellNft.data]);

  return (
    <S.MainSellComponent>
      {loading ? <Loader content="Loading Nft..." /> : ""}
      <MainModel />
      {nftLoading && <Loader content="Loading" />}
      {unlistLoading && <Loader content="unlisting" />}
    

      {web3 && (
        <>
          {error ? (
            <h2>{error}</h2>
          ) : (
            <>
              <MainSell isMainSell={isMainSell}>
                <C.MainContainer>
                  <div className="sellNftMain">
                    <div>
                      <AiOutlineArrowLeft
                        className="leftArrow"
                        onClick={backToUserDetails}
                        color="#fff"
                      />
                      <img
                        src={
                          nftData?.image_preview_url || data?.image || cardImg
                        }
                        width={50}
                        alt=""
                      />
                    </div>
                    <div>
                      <p className="nftTitle">{nftData?.name}</p>
                    </div>
                  </div>
                </C.MainContainer>
              </MainSell>
              <C.MainContainer isSellNftContainer>
                <C.MainRow isSellNftRow>
                  <C.MainCol lg={6}>
                    <S.SellNftTitle>List Item for sale</S.SellNftTitle>
                    <C.MainRow className="g-2 ">
                      <C.MainCol lg={3}>
                        <C.Select
                          inputLabel="Price"
                          dropDownList={paymentTokens}
                          value={value}
                          setValue={(e) => setValue(e)}
                          error={errors.tokenAddress}
                        />
                      </C.MainCol>
                      <C.MainCol lg={9}>
                        <C.InputField
                          placeholder="Amount"
                          inputType="number"
                          isSellNftControl
                          value={amount}
                          error={errors.amount}
                          setValue={(e) => setAmount(e.target.value)}
                        />
                      </C.MainCol>
                    </C.MainRow>

                    {/* <C.DateField label="Duration" /> */}
                    <S.Label>Fee</S.Label>
                    <div className="service">
                      <p className="serviceTitle">Service Fee</p>
                      <p className="serviceValue">2.5%</p>
                    </div>

                    <C.Buttons
                      disabled={
                        createSellNft.loading || unlistLoading ? true : false
                      }
                      onClick={tx?.status === "LISTED" ? unlist : handleSubmit}
                      isNftSellBtn
                    >
                      {tx?.status === "LISTED" ? "unlist" : "Sell"}
                    </C.Buttons>
                  </C.MainCol>

                  <C.MainCol lg={6}>
                    <C.MainCard isSellNftCard>
                      <C.CardImg
                        src={
                          nftData?.image_preview_url || data?.image || cardImg
                        }
                        sellCardImg
                      />
                    </C.MainCard>
                  </C.MainCol>
                </C.MainRow>
              </C.MainContainer>
            </>
          )}
        </>
      )}
    </S.MainSellComponent>
  );
};

export default SellNftComponent;
